import { Component, Input, OnInit } from '@angular/core';
import { Carrera } from '../../models/observacion';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-card-overlay',
  templateUrl: './card-overlay.component.html',
  styleUrls: ['./card-overlay.component.scss']
})
export class CardOverlayComponent implements OnInit {
  @Input() carrera: Carrera
  @Input() borde: boolean = false
  language: any
  @Input() posgrado: boolean = false
  @Input() detalleCurso: boolean = false
  constructor(private aRouter: ActivatedRoute) {
    this.aRouter.params.forEach((params: Params) => {
      this.language = (params['language']) ? params['language'] : 'es';
    });
  }
  redirect(c) {
    if (c.route) {
      window.open(this.language + c.route, '_blank');
    } else if (c.linkCareer) {
      window.open(this.language + c.linkCareer, '_blank');
    }
  }

  cortarTitulo(carrera: { titulo?: string; nombre?: string; title?: string }): string {
    let titulo = "";

    if (carrera.titulo) {
      titulo = carrera.titulo;
    } else if (carrera.nombre) {
      titulo = carrera.nombre;
    } else if (carrera.title) {
      titulo = carrera.title;
    }

    if (titulo) {
      titulo = titulo.length > 50 ? titulo.slice(0, 50) + "..." : titulo;
      return titulo;
    }

    return "";
  }

  formatearFecha(value: any): any {
    if (value.inicio && value.inicio.date) {
      const date = new Date(value.inicio.date);
      const monthNames = [
        "enero", "febrero", "marzo",
        "abril", "mayo", "junio", "julio",
        "agosto", "septiembre", "octubre",
        "noviembre", "diciembre"
      ];

      const day = date.getDate();
      const monthName = monthNames[date.getMonth()];
      const year = date.getFullYear();

      return `${day} de ${monthName} de ${year}`;
    } else {
      return 'CONSULTAR';
    }
  }

  ngOnInit(): void {
  }


}
